import { getMapTBGroupingData, getGroupingData } from "../../../services/api/apiHandler"


export const fetchTTGroupData = (project_id, tb_id) => {
    return dispatch => {
        dispatch({type: "TG_ACTION_START"})
        getMapTBGroupingData(project_id, tb_id).then((result)=>{
            const hasFsGrp = result.data && result.data.fs_grp && result.data.fs_grp.length > 0;
            const isArrayWithData = Array.isArray(result.data) && result.data.length > 0;
            
            if (hasFsGrp || isArrayWithData) {
                let finalData = result.data;
                if (isArrayWithData) {
                    finalData = { fs_grp: result.data };
                }
                dispatch({
                    type: "TG_FETCH_DATA",
                    payload: {data: finalData, set_payload: JSON.stringify({project_id, tb_id})}
                })
            } else {
                // Fallback for translated FS or when mapped grouping is empty
                getGroupingData(project_id).then((fallbackResult) => {
                    let finalData = fallbackResult.data;
                    // If fallback is just an array
                    if (Array.isArray(finalData)) {
                        finalData = { fs_grp: finalData };
                    } else if (finalData && finalData.data && finalData.data.fs_grp) {
                        finalData = finalData.data;
                    }
                    dispatch({
                        type: "TG_FETCH_DATA",
                        payload: {data: finalData, set_payload: JSON.stringify({project_id, tb_id})}
                    })
                }).catch((fallbackErr) => {
                    dispatch({
                        type:"TG_FETCH_DATA_FAILED",
                        payload: fallbackErr.response?.data?.error || fallbackErr.message || "An unexpected error occurred"
                    })
                });
            }
        }).catch((err)=>{
            dispatch({
                type:"TG_FETCH_DATA_FAILED",
                payload: err.response?.data?.error || err.message || "An unexpected error occurred"
            })
        })        
    }
}


export const socketTTGroupUpdate = (response, payload) => {
    return dispatch => {
        dispatch({
            type: "TG_SOCKET_UPDATE_DATA", payload: {
                data: response,
                set_payload: payload
            }
        })
    }
}